import AppBar from '@mui/material/AppBar';
import { ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectFooterTheme,
  selectToolbarTheme,
} from 'app/store/fuse/settingsSlice';
import clsx from 'clsx';

function FooterLayout1(props) {
  const footerTheme = useSelector(selectFooterTheme);
  const toolbarTheme = useSelector(selectToolbarTheme);

  return (
    <ThemeProvider theme={footerTheme}>
      <AppBar
        id='fuse-footer'
        className={clsx('relative z-20 shadow-md', props.className)}
        color='default'
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? footerTheme.palette.background.paper
              : toolbarTheme.palette.background.paper,
        }}
      >
        <Toolbar className='min-h-48 md:min-h-64 px-8 sm:px-12 py-0 flex flex-wrap justify-center md:justify-between items-center text-gray-800 w-full'>
          <span>
            © Copyright {new Date().getFullYear()}. All Rights Reserved.
          </span>
          <span>
            Web Crafted by {' '}

            <a
              href='https://tridentglobal.ai/'
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 hover:underline !text-blue-600 !border-none !bg-transparent'
              style={{ color: '#2563EB' }}
            >
              Trident
            </a>
          </span>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default memo(FooterLayout1);
